import { AfterViewInit, Component } from "@angular/core";
import { FormBuilder, FormGroup, FormArray, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "src/app/shared/services/api.service";
import { ToastrMsgService } from "src/app/shared/services/shared-services/toastr.service";
import * as mapboxgl from 'mapbox-gl';
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import { environment } from "src/environments/environment";
import { PlacePickerComponent } from "src/app/place-picker/place-picker.component";
import { MatDialog } from "@angular/material/dialog";


@Component({
  selector: 'app-edit-branch',
  templateUrl: './edit-branch.component.html',
  styleUrl: './edit-branch.component.css'
})
export class EditBranchComponent implements AfterViewInit {

  userEForm!: FormGroup;
  organizationId: any;
  states: any;
  cities: any;
  searchKeyword = "";
  bList = false
  map!: mapboxgl.Map;
  draw!: MapboxDraw;
  d: any
  constructor(
    private formBuilder: FormBuilder,
    private readonly apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private readonly toastrMsgService: ToastrMsgService, private dialog: MatDialog
  ) {



  }
  ngAfterViewInit(): void { }


  ngOnInit() {
    const editB = localStorage.getItem('editBranch');
    const oneBranch = editB ? JSON.parse(editB) : null;

    // First, initialize the form
    this.userEForm = this.formBuilder.group({
      lat: ['', Validators.required],
      long: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', Validators.required],
      country: ['', Validators.required],
      postal_code: ['', Validators.required],
      org_id: ['', Validators.required],
      branch_id: ['', Validators.required],
      branch_name: ['', Validators.required],
      primary_contact_name: ["", Validators.required],
      primary_contact_email: ["", [Validators.required, Validators.email]],
      primary_contact_phone: ["", [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      registration_number: [""],
      gst_number: ["", [Validators.pattern('^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$')]],
      pan_number: ["", [Validators.pattern('^[A-Z]{5}[0-9]{4}[A-Z]{1}$')]],
      domain: ["", Validators.required],
      address_line_1: ["", Validators.required],
      address_line_2: ["", Validators.required],
    });

    // Get the organization ID
    this.route.params.subscribe((params) => {
      this.organizationId = params['id'];

      // Now safely call editData()
      if (this.organizationId && oneBranch) {
        this.editData(oneBranch);
      }
    });
  }

  editData(data: any) {
    if (!data || !this.userEForm) return;
    if (data.domain != null) {
      this.d = data.domain.split(',').map((s: string) => s.trim())

    } else {
      this.d = data.domain

    }
    this.userEForm.patchValue({
      lat: data.lat,
      long: data.long,
      city: data.city,
      state: data.state,
      country: data.country,
      postal_code: data.postal_code,
      branch_name: data.branch_name,
      primary_contact_name: data.primary_contact_name,
      primary_contact_email: data.primary_contact_email,
      primary_contact_phone: data.primary_contact_phone,
      org_id: data.org_id,
      branch_id: data.branch_id,
      address_line_1: data.address_line_1,
      address_line_2: data.address_line_2,
      domain: this.d,
      registration_number: data.registration_number,
      gst_number: data.gst_number,
      pan_number: data.pan_number,

    });
    this.onCountryChange();
    this.onStateChange();
    this.bList = true;
  }


  onSubmit(): void {
    console.log(this.userEForm.value.domain?.join(', '))
    const formValue = this.userEForm.value;
    const payload = {
      ...formValue,
      domain: formValue.domain.join(',') 
    };
    console.log(payload)
    this.apiService.updateOrganizationBranch(this.organizationId, payload).subscribe({
      next: (res) => {
        this.toastrMsgService.success('Branch update successfully');
        this.router.navigate(['/home/organization-branch-list', this.userEForm.value.org_id]);

      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log("Observable complete"),
    });

  }

  onCountryChange() {
    const country = this.userEForm.value.country;
    // console.log(country)

    // const selectedCountry = this.countries.find(c => c.name === country);
    // this.states = selectedCountry ? selectedCountry.states : [];
    this.apiService.getstates().subscribe({
      next: (res) => {
        console.log(res);
        this.states = res
      },
      error: (err) => {
        console.error(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log("Observable complete"),
    });
    this.cities = [];
    if (this.organizationId) {
      this.userEForm.patchValue({ state: this.userEForm.value.state, city: this.userEForm.value.city });

    } else {
      this.userEForm.patchValue({ state: '', city: '' });

    }

  }


  onStateChange() {
    const state = this.userEForm.value.state;
    // const selectedState = this.states.find(s => s.name === state);
    // this.cities = selectedState ? selectedState.cities : [];
    // this.userAForm.patchValue({ city: '' });
    this.apiService.getdistricts(state).subscribe({
      next: (res) => {
        console.log(res);
        this.cities = res;
      },
      error: (err) => {
        console.error(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log("Observable complete"),
    });
    if (this.organizationId) {
      this.userEForm.patchValue({ city: this.userEForm.value.city });

    } else {
      this.userEForm.patchValue({ city: '' });

    }
  }

  openPicker() {
    const dialogRef = this.dialog.open(PlacePickerComponent, {
      width: '600px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        console.log('Selected Coordinates:', result);
        this.userEForm.patchValue({
          lat: result.lat,
          long: result.lng
        });
      }
    });
  }


}
